import { useState } from 'react';
import {
  approveProposal, rejectProposal,
} from '../../services/agent';

export function ApprovalBar({
  proposalId,
  selectedIds,
  payloadEdits,
  onDone,
}: {
  proposalId: string;
  selectedIds: string[];
  payloadEdits: Record<string, any>;
  onDone: () => void;
}) {
  const [busy, setBusy] = useState(false);

  const doApprove = async () => {
    setBusy(true);
    try {
      await approveProposal(proposalId, {
        action_ids: selectedIds,
        payload_edits: payloadEdits,
      });
      onDone();
    } finally {
      setBusy(false);
    }
  };

  const doReject = async () => {
    setBusy(true);
    try {
      await rejectProposal(proposalId);
      onDone();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cgm-approval-bar fixed bottom-0 right-0 z-40 backdrop-blur-md bg-white/70 dark:bg-neutral-900/70" data-tour="agent-approval-bar">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-3 flex gap-2">
        <button
          onClick={doApprove}
          disabled={busy || selectedIds.length === 0}
          className="px-4 py-2 bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900 disabled:opacity-50"
        >
          Approve selected ({selectedIds.length})
        </button>
        <button
          onClick={doReject}
          disabled={busy}
          className="px-4 py-2 border border-neutral-300 dark:border-neutral-600 dark:text-neutral-100"
        >
          Reject
        </button>
      </div>
    </div>
  );
}
